import React from "react";

function NavBar() {
    return (
        <div id="nav-bar">
            <ul className="nav-left">
                <li>
                    <a href="/" className="nav-logo-link">
                        <img src="./images/assets/nochill_logo.png" alt="NOCHILL Logo" className="nav-logo" />
                        nochillio
                    </a>
                </li>
            </ul>
            <ul className="nav-menu">
                <li>
                    <a
                        href="https://salvor.io/collections/0x204b3ee3f9bdcde258ba3f74de76ea8eedf0a36a"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        BUY NOCHILLIO
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.phar.gg/trade?inputCurrency=0x0000000000000000000000000000000000000000&outputCurrency=0xAcFb898Cff266E53278cC0124fC2C7C94C8cB9a5"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        BUY NOCHILL
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.tradingview.com/symbols/NOCHILLWAVAX_2D38BD.USD/?offer_id=10&aff_id=5962"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        CHART
                    </a>
                </li>
            </ul>
        </div>
    );
}

export default NavBar;
